
import { GetterTree } from 'vuex';
import { IPropertyEditState } from '../property-states.store';

const smoovedGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
  service: (state: IPropertyEditState) => state.service,
  smooved: (state: IPropertyEditState) => state.smooved,
  PrimaryContact: (state: IPropertyEditState) => state.smooved.PrimaryContact,
  //SecondaryContact: (state: IPropertyEditState) => state.smooved.SecondaryContact,
  LeavingCustomer: (state: IPropertyEditState) => state.smooved.LeavingCustomer,
  Connection: (state: IPropertyEditState) => state.smooved.Connection,
}

export default smoovedGetters;